var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"gofixButton gofixElement",class:{
            gofixButtonLarge:_vm.large,
            gofixButtonSmall:_vm.small,
            gofixButtonUnsetMinWidth:_vm.unsetMinWith,
            gofixButtonWhiteSpace:_vm.whiteSpace,
            gofixButtonFontNormal:_vm.fontNormal,
            gofixButtonDark:_vm.dark,
            gofixButtonDisable:_vm.disabled,
            gofixButtonLoading:_vm.loading,
            gofixButtonNoBorder:_vm.noBorder,
            gofixButtonOutLine:_vm.outline,
            gofixButtonMarginTopFive:_vm.marginTopFive
        },on:{"click":_vm.handleClick}},[(_vm.loading)?_c('b-spinner',{attrs:{"small":"","type":"grow"}}):_vm._e(),_c('span',[_vm._t("gofix:button:beforeLabel"),_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._t("gofix:button:afterLabel")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }